<template>
    <div
        v-if="iconUrl"
        class="content-icon-wrapper"
    >
        <div
            class="content-icon"
            :class="{ 'circle': circle }"
            :style="{ height: height }"
        >
            <img
                :src="iconUrl"
                alt="image"
            >
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
    icon?: string | null
    iconUrl?: string | null
    circle?: boolean
    size?: number | string
}>()

const iconUrl = computed(() => props.icon && new URL(`../assets/icons/${props.icon}`, import.meta.url).href)

const height = computed(() => {
    if (typeof props.size === 'number') {
        return `${props.size}px`
    }

    return props.size
})
</script>
